export default "__VITE_ASSET__B2eF3BOu__"